// Fixed DD.MM.YYYY HH:mm, matching the app-wide moment(...).format("DD.MM.YYYY HH:mm")
// convention used everywhere else (tl-module-workorder-history.js, application.js, etc.) -
// deliberately not locale-dependent, same as those call sites. Implemented without a moment.js
// dependency so components consuming this via @tl-shared don't have to pull it in.
export function formatTimestamp(value: number): string {
  const date = new Date(value);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
